<template>
  <div>
    <!-- <mheader></mheader> -->
    <!-- 表单内容 -->
    <div v-show="tableData.length>0" style="width:1300px;margin:0 auto;" id="v-content" :style="{minHeight:Height+'px'}">
           <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">
          <p class="mt-2" style="font-size:0.9rem;">
             <img src="../../../static/images/chaxun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
                <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                    调价记录
                </span>
                <span class="ml-5">
                    查询时间: 从
                    <span style="color:red">
                        {{searchForm.DateLessThan | changeDate}}
                    </span>
                    到
                    <span style="color:red">
                      {{searchForm.DateMoreThan | changeDate1}}
                    </span>
                </span>
                     
                    <span class="ml-5">

                        总共有
                        <span style="color:green;font-size:20px">{{Record}}</span>
                        条数据
                        <!-- <span class="ml-3">
                           查询数量:
                        </span>
                        <span class="totalNum">{{totalNum}}</span>
                        <span class="ml-3">
                           本页金额总计:
                        </span>
                        <span class="money">¥{{pageTotalMoney}}</span>
                        <span class="ml-3">
                              查询总金额总计:
                        </span>
                       <span class="money">¥{{totalMoney}}</span> -->
                    </span>
                    <span class="float-right span_close mr-1" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                    </span>
            </p>
             <p class="mb-2 mt-2">
               <span style="font-weight:600;color:red;">(双击药品名称或者生产厂家可以快速检索！)</span>
            </p>
            <div class="row ml-2 mb-2">
                     <div class="col-lg-6">
                          <div class="row">
                             <div class="col-lg-12">
                                 <div class="row">
                                        <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        药品名称:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.ypmc" style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        批号:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.ph"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        生产厂家:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.cdmc"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        规格:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.gg"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                 </div>

                             </div>

                          </div>

                       </div>
                        <div class="col-lg-6">
                                <div class="row">
                                        <div class="col-lg-7">
                            <div class="row">
                                <div class="col-lg-6">
                                   <div class="row">
                                      <div class="col-lg-6 P-0">
                                          <div class="row ml-lg-1 p-0 font">
                                              记录日期:
                                          </div>
                                      </div>
                                      <div class="col-lg-6 p-0">
                                              <date @changeDate="changeDate1($event)"/>
                                      </div>
                                </div>
                              </div>
                              <div class="col-lg-6">
                                  <div class="row">
                                      <div class="col-lg-6 p-0 text-center font">
                                             到:
                                      </div>
                                      <div class="col-lg-6 p-0">
                                          <date class="picker2"  @changeDate="changeDate2($event)"/>
                                      </div>
                                  </div>
                              </div>
                          </div>
                       </div>
                       <div class="col-lg-5">
                           <div class="row ml-lg-2 ">
                                 <button class="bg-primary button_zi  hei" @click="Search()">查询</button>
                                 <!-- <button class="bg-success button_zi ml-lg-1" @click="exportExcel1()">导出本页EXCEL</button>
                                 <button class="bg-success button_zi ml-lg-1" @click="exportExcel()">导出查询EXCEL</button> -->
                           </div>
                       </div>
                      </div>
                  </div>
                </div>
      <table v-if="searchData.length>0" class="table table-striped table-hover" ref="print">
        <thead>
        <tr style="white-space: nowrap;">
          <th>药品名称</th>
          <th>产地名称</th>
          <th>库区</th>
          <th>规格</th>
          <th>批号</th>
          <th>包装</th>
          <th>批准文号</th>
          <th>批量价</th>
          <th>零批价</th>
          <th>进价</th>
          <th>调价后批量价</th>
          <th>调价后零批价</th>
          <th>创建时间</th>
		   <th>备注</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item,index) in searchData" :key="index">
          <td @dblclick="onInputdrugName(index)">{{item.drugName}}</td>
          <td @dblclick="onInputcustomerName(index)">{{item.factory}}</td>
          <td>{{item.storeNo}}</td>
          <td>{{item.spec}}</td>
          <td>{{item.batchNo}}</td>
          <td>{{item.pack}}</td>
          <td>{{item.approvalNo}}</td>
          <td>{{item.tradePrice}}</td>
          <td>{{item.retailPrice}}</td>
          <td>{{item.purchPrice}}</td>
          <td>{{item.aftTradePrice}}</td>
          <td>{{item.aftRetailPrice}}</td>
          <td>{{item.createDate | formatUTC}}</td>
		  <td style="colro:green;">{{item.remark}}</td>
        </tr>
        </tbody>
      </table>
      <table class="table table-striped table-hover" ref="print" v-else>
        <thead>
        <tr style="white-space: nowrap;">
          <th>药品名称</th>
          <th>产地名称</th>
          <th>库区</th>
          <th>规格</th>
          <th>批号</th>
          <th>包装</th>
          <th>批准文号</th>
          <th>批量价</th>
          <th>零批价</th>
          <th>进价</th>
          <th>调价后批量价</th>
          <th>调价后零批价</th>
          <th>创建时间</th>
        
		   <th>备注</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item,index) in tableData" :key="index">
          <td @dblclick="onInputdrugName(index)">{{item.drugName}}</td>
          <td @dblclick="onInputcustomerName(index)">{{item.factory}}</td>
          <td>{{item.storeNo}}</td>
          <td>{{item.spec}}</td>
          <td>{{item.batchNo}}</td>
          <td>{{item.pack}}</td>
          <td>{{item.approvalNo}}</td>
          <td>{{item.tradePrice}}</td>
          <td>{{item.retailPrice}}</td>
          <td>{{item.purchPrice}}</td>
          <td>{{item.aftTradePrice}}</td>
          <td>{{item.aftRetailPrice}}</td>
          <td>{{item.createDate | formatUTC}}</td>
		  <td style="color:green;">{{item.remark}}</td>
        </tr>
        </tbody>
      </table>
      <!-- 分页 -->

      <!-- <nav aria-label="Page navigation" style="text-align:center;" v-if="this.Pcount!==0" class="mb-1">
        <ul class="pagination">
          <li class="page-item ml-5" :class="PageNo<=1?'disabled':''" @click="prePage()">
            <a aria-label="Previous" class="page-link">
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>
               <li :class="index==PageNo?'active':''" class="page-item" v-for="index of Pcount" :key="index"
                                                @click="curPage(index)">
                                                <a class="page-link" v-if="index<=20">{{index}}</a>
                                                <a class="page-link" v-if="index>20 && index==(Pcount-1)">...</a>
                                                <a class="page-link" v-if="index>20 && index==Pcount">{{Pcount}}</a>
                                            </li>

          <li class="page-item" :class="PageNo>=Pcount?'disabled':''" @click="nextPage()">
            <a aria-label="Next" class="page-link">
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
        </ul>
      </nav> -->



                <div>
                       <v-pagination :total="total" :current-page='current' @pagechange="pagechange"></v-pagination>
                </div>




      
      <p class="text-center">
        <img src="../../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
      </p>
       <!-- <p class="text-center">

          总共有
          <span style="color:green;font-size:20px">{{Record}}</span>
          条数据
          查询数量:<span class="money">{{totalNum}}</span>
          本页金额总计:<span class="money">¥{{pageTotalMoney}}</span>
          查询总金额总计:<span class="money">¥{{totalMoney}}</span>

       </p> -->
       <!-- <p>
         查询时间: 从
         <span style="color:red">
             {{searchForm.DateLessThan | changeDate}}
         </span>
         到
         <span style="color:red">
           {{searchForm.DateMoreThan | changeDate1}}
         </span>
       </p> -->
    </div>
    </div>



     <div v-show="Pcount===0" style="width:1300px;margin:0 auto;" id="v-content" :style="{minHeight:Height+'px'}">
           <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">
          <p class="mt-2" style="font-size:0.9rem;">
             <img src="../../../static/images/chaxun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
                <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                    调价记录
                </span>
                <span class="ml-5">
                    查询时间: 从
                    <span style="color:red">
                        {{searchForm.DateLessThan | changeDate}}
                    </span>
                    到
                    <span style="color:red">
                      {{searchForm.DateMoreThan | changeDate1}}
                    </span>
                </span>
                     
                    <span class="ml-5">

                        总共有
                        <span style="color:green;font-size:20px">{{Record}}</span>
                        条数据
                        <!-- <span class="ml-3">
                           查询数量:
                        </span>
                        <span class="totalNum">{{totalNum}}</span>
                        <span class="ml-3">
                           本页金额总计:
                        </span>
                        <span class="money">¥{{pageTotalMoney}}</span>
                        <span class="ml-3">
                              查询总金额总计:
                        </span>
                       <span class="money">¥{{totalMoney}}</span> -->
                    </span>
                    <span class="float-right span_close mr-1" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                    </span>

                  
            </p>
             <p class="mb-2 mt-2">
               <span style="font-weight:600;color:red;">(双击药品名称或者生产厂家可以快速检索！)</span>
            </p>
            <div class="row ml-2 mb-2">
                     <div class="col-lg-6">
                          <div class="row">
                             <div class="col-lg-12">
                                 <div class="row">
                                        <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        药品名称:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.ypmc" style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        批号:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.ph"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        生产厂家:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.cdmc"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        规格:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.gg"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                 </div>

                             </div>

                          </div>

                       </div>
                        <div class="col-lg-6">
                                <div class="row">
                                        <div class="col-lg-7">
                            <div class="row">
                                <div class="col-lg-6">
                                   <div class="row">
                                      <div class="col-lg-6 P-0">
                                          <div class="row ml-lg-1 p-0 font">
                                              记录日期:
                                          </div>
                                      </div>
                                      <div class="col-lg-6 p-0">
                                              <date @changeDate="changeDate1($event)"/>
                                      </div>
                                </div>
                              </div>
                              <div class="col-lg-6">
                                  <div class="row">
                                      <div class="col-lg-6 p-0 text-center font">
                                             到:
                                      </div>
                                      <div class="col-lg-6 p-0">
                                          <date class="picker2"  @changeDate="changeDate2($event)"/>
                                      </div>
                                  </div>
                              </div>
                          </div>
                       </div>
                       <div class="col-lg-5">
                           <div class="row ml-lg-2 ">
                                 <button class="bg-primary button_zi  hei" @click="Search()">查询</button>
                                 <!-- <button class="bg-success button_zi ml-lg-1" @click="exportExcel1()">导出本页EXCEL</button>
                                 <button class="bg-success button_zi ml-lg-1" @click="exportExcel()">导出查询EXCEL</button> -->
                           </div>
                       </div>
                      </div>
                  </div>
                </div>
            <img src="../../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">
      <p class="text-center">
        <img src="../../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
      </p>
       <!-- <p class="text-center">

          总共有
          <span style="color:green;font-size:20px">{{Record}}</span>
          条数据
          查询数量:<span class="money">{{totalNum}}</span>
          本页金额总计:<span class="money">¥{{pageTotalMoney}}</span>
          查询总金额总计:<span class="money">¥{{totalMoney}}</span>

       </p> -->
       <!-- <p>
         查询时间: 从
         <span style="color:red">
             {{searchForm.DateLessThan | changeDate}}
         </span>
         到
         <span style="color:red">
           {{searchForm.DateMoreThan | changeDate1}}
         </span>
       </p> -->
    </div>
    </div>

    <div>
      <transition name='fade'>
        <loading v-if="isLoading"></loading>
      </transition>
    </div>
    <!-- Footer -->
    <!-- <mfooter></mfooter> -->
  </div>
</template>
<script>
  import vPagination from "../../components/Pagination.vue"
  import Loading from '../../components/Loading.vue'
  import date from '../../components/Date.vue'


  export default {
    name: 'SaleQuery',
    data() {
      return {
        date: new Date(),
         Height:0,
        searchForm: {
          ypmc: '',
          cdmc: '',
          ph: '',
          gg: '',
          DateMoreThan: '',
          DateLessThan: '' ,
          DateLessThan1: '',
          DateMoreThan1: '',// 今天+1
        },//搜索内容
        searchData: [],//搜索返回的清单
        isLoading: false,
        tableData: [],
        Record: '',//总记录数
        Pcount: '',//总页数
        PageNo: 1 ,//当前页码
        totalMoney:'',
        totalNum:'',
        pageTotalMoney:'',
        excelData:[],


         total:1,     // 记录总条数
            display: 20,   // 每页显示条数
            current: 1,   // 当前的页数

      }
    },
    components: {
        vPagination,
      Loading,
      date

    },
    computed: {},
    filters: {
      //过滤器时间转换
      //时间转换
      formatUTC: function (utc_datetime) {
           return utc_datetime.replace(/T/ig,"  ").substring(0,20)
      },
      changeDate(date){
           let change_date=date.slice(0,4)+"-"+date.slice(4,6)+"-"+date.slice(6,9)
           return change_date+" 00:00:00"
      },
      changeDate1(date){
         let time_change=date.slice(0,4)+"-"+date.slice(4,6)+"-"+date.slice(6,9)
        let year=new Date(new Date(time_change).getTime()-24*60*60*1000).getFullYear();

        let month=new Date(new Date(time_change).getTime()-24*60*60*1000).getMonth()+1;

        let time_date=new Date(new Date(time_change).getTime()-24*60*60*1000).getDate();

        let time;
             if(month<10){
                      if(time_date<10)
                       time=year+"-"+"0"+month+"-"+'0'+time_date;
                      else{
                        time=year+"-"+"0"+month+"-"+time_date;
                      }
                  }
                  else{
                     if(time_date<10){
                       time=year+"-"+month+"-"+"0"+time_date;
                     }
                     else{
                       time=year+"-"+month+"-"+time_date;
                     }
                  }

         let change_date=time;
           return change_date+" 23:59:59"
      }
    },

    methods: {
	
	formatUTC: function (utc_datetime) {
           return utc_datetime.replace(/T/ig,"  ").substring(0,20)
      },
      searchEnterFun(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.Search();
         }
      },
	getisGoodsForward(isGoodsForward){
	// console.log(isGoodsForward)
			if(isGoodsForward){
			  return "是";
			}else{
				return "否"
			}
	},
      //导出查询
      exportExcel() {
                 const that=this
                require.ensure([], async () => {
                  const { export_json_to_excel } = require('../../Excel/Export2Excel');//注意这个Export2Excel路径
                  const tHeader = ["药品名称","产地名称","库区","规格","批号","单位","单价","数量","金额","发票号（第三位标识公司）","是否货物迁移","记账日期","远程订单"]; // 上面设置Excel的表格第一行的标题
                  const filterVal = ['drugName', 'productFactory', 'storeNo','spec','batchNo','unit','price','storeNum','storeMoney','saleNo','isGoodsForward','accountDate','state']; // 上面的index、nickName、name是tableData里对象的属性key值
                  await that.getExcelData()
                  const list = that.excelData;
                  const data = that.formatJson(filterVal, list);
                  export_json_to_excel(tHeader, data, '销售查询');//最后一个是表名字
                })
              },
              formatJson(filterVal, jsonData) {
			  
                return jsonData.map(
					v => filterVal.map(
					    
						 j => v[j]
						)
				)
              },
          //导出本页
          exportExcel1() {
            require.ensure([], () => {
              const { export_json_to_excel } = require('../../Excel/Export2Excel');//注意这个Export2Excel路径
                  const tHeader = ["药品名称","产地名称","库区","规格","批号","单位","单价","数量","金额","发票号（第三位标识公司）","是否货物迁移","记账日期","远程订单"]; // 上面设置Excel的表格第一行的标题
                  const filterVal = ['drugName', 'productFactory', 'storeNo','spec','batchNo','unit','price','storeNum','storeMoney','saleNo','isGoodsForward','accountDate','state']; // 上面的index、nickName、name是tableData里对象的属性key值
                  if(this.searchData.length>0){
                           const list = this.searchData;  //把要导出的数据tableData存到list
                        const data = this.formatJson(filterVal, list);
                        export_json_to_excel(tHeader, data, '销售查询');//最后一个是表名字
                  }
                  else{
				 
                    const list = this.tableData;  //把要导出的数据tableData存到list
                    const data = this.formatJson(filterVal, list);
                    export_json_to_excel(tHeader, data, '销售查询');//最后一个是表名字
                  }
                })
              },
              formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
              },
       time:function(){
                 let year=this.date.getFullYear();
                 let month=this.date.getMonth()+1;
                 let time_date=this.date.getDate()+1;
                 let time;
                  if(month<10){
                      if(time_date<10)
                       time=''+year+"0"+month+'0'+time_date;
                      else{
                        time=''+year+"0"+month+time_date;
                      }
                  }
                  else{
                     if(time_date<10){
                       time=''+year+month+"0"+time_date;
                     }
                     else{
                       time=''+year+month+time_date;
                     }
                  }

                  this.searchForm.DateMoreThan=time;



       },
        //动态绑定时间
      changeDate1:function(date){
         this.searchForm.DateLessThan=date.replace(/\-/g, "")
          this.searchForm.DateLessThan1=date;
        },
      changeDate2:function(date){
        let year=new Date(new Date(date).getTime()+24*60*60*1000).getFullYear();

        let month=new Date(new Date(date).getTime()+24*60*60*1000).getMonth()+1;

        let time_date=new Date(new Date(date).getTime()+24*60*60*1000).getDate();
        // console.log(time_date)
        let time;
             if(month<10){
                      if(time_date<10)
                       time=''+year+"0"+month+'0'+time_date;
                      else{
                        time=''+year+"0"+month+time_date;
                      }
                  }
                  else{
                     if(time_date<10){
                       time=''+year+month+"0"+time_date;
                     }
                     else{
                       time=''+year+month+time_date;
                     }
                  }

          this.searchForm.DateMoreThan=time;
          // console.log(time)
          this.searchForm.DateMoreThan1=date;
      },
        //验证
          // ypmc:function(){
          //     let reg1=/^[\u4e00-\u9fa5]{0,}$/;
          //      if(!reg1.test(this.searchForm.ypmc)){
          //            $("#ypmc").removeClass("d-none")
          //      }
          //      else{
          //           $("#ypmc").addClass("d-none")
          //      }
          // },
          // ph:function(){
          //      let reg2=/^[0-9]*$/;
          //      if(!reg2.test(this.searchForm.ph)){
          //            $("#ph").removeClass("d-none")
          //      }
          //      else{
          //           $("#ph").addClass("d-none")
          //      }
          // },
          // sccj:function(){
          //       let reg3=/^[\u4e00-\u9fa5]{0,}$/;
          //       if(!reg3.test(this.searchForm.cdmc)){
          //            $("#sccj").removeClass("d-none")
          //      }
          //      else{
          //            $("#sccj").addClass("d-none")
          //      }
          // },

      onInputdrugName:function(index){
          if(this.searchData.length>0){
            this.searchForm.ypmc=this.searchData[index].drugName;
          }
          else {
            this.searchForm.ypmc=this.tableData[index].drugName;
          }
      },
      onInputcustomerName:function(index){
          if(this.searchData.length>0)
          {
             this.searchForm.cdmc=this.searchData[index].productFactory
          }
          else
          {
            this.searchForm.cdmc=this.tableData[index].productFactory;
          }
      },

      getSaleQuery: async function (PageIndex) {
        // this.isLoading=true;
		let that=this;
        const {data: res} = await that.$http.post('Dls/getFun', {
          action: 'ClerkAdJustPriceDetail',
          obj: JSON.stringify({
            PageIndex,
            PageSize: 20,
            DateLessThan: that.searchForm.DateMoreThan,
            DateMoreThan: that.searchForm.DateLessThan, // 销售日期不小于
          })
        })
        // console.log(res)
        if (res.isok) {
          // this.isLoading = false
          const obj = res.data
		  // for(let i=0;i<obj.rows.length;i++){
			// if(obj.rows[i].isGoodsForward){
			// 	obj.rows[i].isGoodsForward="是"
			// }else{
			// obj.rows[i].isGoodsForward="否"
			// }
			// // obj.rows[i].accountDate=that.formatUTC(obj.rows[i].accountDate)
		  // }
          that.Pcount = obj.pcount
          that.tableData = obj.rows
          that.total = obj.record
          that.excelData= obj.rows
          that.Record = obj.record
          that.totalNum = obj.totalNum
          that.totalMoney =obj.totalMoney
          that.pageTotalMoney=obj.pageTotalMoney
        }
      },
      //查询
      getExcelData: async function () {
	  let that=this;
        const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkSaleQuery',
          obj: JSON.stringify({
             PageIndex:1,
             PageSize:50000,
             DrugName: that.searchForm.ypmc.trim(),
             BatchNum: that.searchForm.ph.trim(),
             ProductFactory: that.searchForm.cdmc.trim(),
             Spec: that.searchForm.gg.trim(),
            DateLessThan: that.searchForm.DateMoreThan,
            DateMoreThan: that.searchForm.DateLessThan,
          })
        })
        // console.log(res)
        if (res.isok) {
          const obj = res.data;
		  for(let i=0;i<obj.rows.length;i++){
			if(obj.rows[i].isGoodsForward){
				obj.rows[i].isGoodsForward="是"
			}else{
			obj.rows[i].isGoodsForward="否"
			}
			obj.rows[i].accountDate=that.formatUTC(obj.rows[i].accountDate)
		  }
          that.excelData = obj.rows


        }
      },
      // 获取当前时间，day为number，getDay(-1):昨天的日期;getDay(0):今天的日期;getDay(1):明天的日期;【以此类推】
            getDay(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
                return tYear+"-" + tMonth+"-" + tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },
             getDay1(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                　　
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
                return tYear + "" + tMonth + "" + tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },
      Search: async function (PageIndex) {
        //获取三个月前的时间戳   时间条件适合才可以查询

        const that = this
        let  threeMonth=that.getDay(-3*30);

        let  threeMonthTime=new Date(threeMonth).getTime()

        let  today=that.getDay(0);
        let  todayTime=new Date(today).getTime();

        let  select=that.searchForm.DateLessThan1;

        let  select1=that.searchForm.DateMoreThan1;
        let  seTime=new Date(select).getTime();

        let  seTime2=new Date(select1).getTime();

        let ces=that.searchForm.DateLessThan;
         let a=ces.slice(0,4)+"-"+ces.slice(4,6)+"-"+ces.slice(6,9)
        // console.log(a)
        let ces1=that.searchForm.DateMoreThan;
        let b=ces1.slice(0,4)+"-"+ces1.slice(4,6)+"-"+ces1.slice(6,9)
        // console.log(b)
        let cesTime=new Date(a).getTime();
        // console.log(cesTime)
        let cesTime2=new Date(b).getTime();
        // console.log(cesTime2)
        if(cesTime>=cesTime2){
          alert("开始日期要小于结束日期")
        }
        else{

          if((threeMonthTime<=seTime&&seTime<=todayTime) && (threeMonthTime<=seTime2&&seTime2<=todayTime)){

            that.isLoading=true;
            if(!PageIndex){PageIndex=1}
            that.PageNo = PageIndex || that.PageNo
            const {data: res} = await this.$http.post('Dls/getFun', {
              action: 'ClerkAdJustPriceDetail',
              obj: JSON.stringify({
                PageIndex,
                PageSize: 20,
                DrugName: that.searchForm.ypmc.trim(),
                BatchNum: that.searchForm.ph.trim(),
                ProductFactory: that.searchForm.cdmc.trim(),
                Spec: that.searchForm.gg.trim(),
                DateLessThan: that.searchForm.DateMoreThan,  // 销售日期不小于
                DateMoreThan: that.searchForm.DateLessThan, // 销售日期不大于
              })
            })

            // console.log(res)
            if(res.isok){
                  const obj = res.data;
			// 	  for(let i=0;i<obj.rows.length;i++){
			// if(obj.rows[i].isGoodsForward){
			// 	obj.rows[i].isGoodsForward="是"
			// }else{
			// obj.rows[i].isGoodsForward="否"
			// }
			// obj.rows[i].accountDate=that.formatUTC(obj.rows[i].accountDate)
		  // }
                   if(that.Pcount===0){
                      that.tableData = obj.rows
                   }
                   else{
                     that.searchData = obj.rows
                   }
                  that.Pcount = obj.pcount
                  that.total = obj.record
                  that.Record = obj.record
                  that.totalNum = obj.totalNum
                  that.totalMoney =obj.totalMoney
                  that.pageTotalMoney=obj.pageTotalMoney
                  that.isLoading=false;
                  if(obj.pcount==0){
                        alert('没有符合条件的信息')
                         that.getSaleQuery();
                  }


          }

          }
          else{
            alert("请选择三个月以内的时间进行查询,查询日期不大于当天")
          }

        }

      },
     

      pagechange:function(currentPage){
         if(this.searchData.length>0){
           this.Search(currentPage)
         }else{

           this.getSaleQuery(currentPage);
         }
     },
      //搜索功能

      // 打印
      start_print() {
        this.$print(this.$refs.print);//$refs的值要和html里的ref一致
      }

    },
     mounted(){
          //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100;  
　　//监听浏览器窗口变化　
    window.onresize = ()=> {this.Height = document.documentElement.clientHeight -100}
  
    },
    created() {
      // this.time();
      this.searchForm.DateMoreThan=this.getDay1(1)
      this.searchForm.DateLessThan=this.getDay1(0)
      this.getSaleQuery();
      this.searchForm.DateLessThan1=this.getDay(-1)
      this.searchForm.DateMoreThan1=this.getDay(0)
    }
  }
</script>
<style scoped>
  .table-hover > tbody > tr:hover {
    background-color: #dee2e6 !important;
  }
  .hei{
    height:1.5rem;
  }
  .font{
    font-size:15px;
  }
  .totalNum{
    color:green;
    font-weight:500;
  }
  .font_yz{
    font-size:1px;
    color:red;
  }
  .button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .money{
      color:red;
      font-weight: 500;
  }
 .span_close:hover{
       color:#3190e8;
 }

</style>



// WEBPACK FOOTER //
// src/pages/Record/AdjustRecord.vue